import React, { CSSProperties } from 'react'

import { PrimaryButtonLabel, PrimaryButtonLabels } from './PrimaryButtonLabel'
import PrimaryButtonIcon from './PrimaryButtonIcon/PrimaryButtonIcon'
import { tutorialDataTestIds } from '../mocks/tutorial-mocks'
import { TutorialElementProps } from '../Tutorial/Tutorial'

import styles from './PrimaryButton.module.scss'

type PrimaryButtonProps = {
  primaryProps: TutorialElementProps
  style?: CSSProperties
  className?: string
}

const PrimaryButton = ({
  primaryProps,
  style,
  className = '',
}: PrimaryButtonProps) => {
  const ariaLabel = primaryProps['aria-label'] as PrimaryButtonLabels

  return (
    <button
      type="button"
      {...primaryProps}
      className={`${styles.primaryButton} ${className}`}
      style={{ ...style }}
      data-testid={tutorialDataTestIds.primaryButton}
    >
      <div className={styles.primaryButtonContent}>
        <PrimaryButtonLabel label={ariaLabel} />
        <PrimaryButtonIcon label={ariaLabel} />
      </div>
    </button>
  )
}

export default PrimaryButton
